import { createSlice } from '@reduxjs/toolkit';

import { initialState } from './initialState';
import {
  addBuilding,
  changeBuilding,
  fetchBuildings,
  removeBuilding,
} from './services';

export const buildingsSlice = createSlice({
  name: 'buildings',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder.addCase(fetchBuildings.pending, (state, action) => {
      state.error = undefined;
      state.currentRequests.add(action.meta.arg.townId);
    });
    builder.addCase(fetchBuildings.rejected, (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.currentRequests.delete(action.meta.arg.townId);
    });
    builder.addCase(fetchBuildings.fulfilled, (state, action) => {
      state.loading = false;
      state.currentRequests.delete(action.meta.arg.townId);
      const buildingIds = new Set<number>();

      for (const building of action.payload) {
        state.buildingsById.set(building.buildingId, building);
        buildingIds.add(building.buildingId);
      }

      if (buildingIds.size) {
        state.buildingsByTowns.set(action.meta.arg.townId, buildingIds);
      } else {
        state.buildingsByTowns.delete(action.meta.arg.townId);
      }
    });

    builder.addCase(removeBuilding.fulfilled, (state, action) => {
      const building = state.buildingsById.get(action.meta.arg);
      if (!building) return;

      state.buildingsById.delete(building.buildingId);
      const nextBuildingsByTown = state.buildingsByTowns.get(building.townId);
      if (!nextBuildingsByTown) return;

      nextBuildingsByTown.delete(building.buildingId);
      if (nextBuildingsByTown.size) {
        state.buildingsByTowns.set(building.townId, nextBuildingsByTown);
      } else {
        state.buildingsByTowns.delete(building.townId);
      }
    });

    builder.addCase(addBuilding.fulfilled, (state, action) => {
      state.buildingsById.set(action.payload.buildingId, action.payload);
      const nextBuildingsByTown =
        state.buildingsByTowns.get(action.payload.townId) ?? new Set<number>();
      nextBuildingsByTown.add(action.payload.buildingId);
      state.buildingsByTowns.set(action.payload.townId, nextBuildingsByTown);
    });

    builder.addCase(changeBuilding.fulfilled, (state, action) => {
      state.buildingsById.set(action.payload.buildingId, action.payload);
      const nextBuildingsByTown =
        state.buildingsByTowns.get(action.payload.townId) ?? new Set<number>();
      nextBuildingsByTown.add(action.payload.buildingId);
      state.buildingsByTowns.set(action.payload.townId, nextBuildingsByTown);
    });
  },
});

export const { actions: buildingsActions, reducer: buildingsReducer } =
  buildingsSlice;
